


















import Vue from "vue";
import ProjectsList from "@/components/ProjectsList.vue";
import toolProjectsData from "@/data/ToolProjectsData.ts";

export default Vue.extend({
  name: "ToolProjects",
  components: {
    ProjectsList,
  },
  data: function () {
    return {
      projects: toolProjectsData,
    };
  },
});
